import { MenuItem } from '@ui-lib/components';
import { LanguageCode } from '../../../core/services/language/language.const';

export const LANGUAGE_MENU_ITEMS: MenuItem[] = [
  {
    id: LanguageCode.en,
    titleTranslateKey: 'language.en',
  },
  {
    id: LanguageCode.ru,
    titleTranslateKey: 'language.ru',
  },
  {
    id: LanguageCode.zh,
    titleTranslateKey: 'language.zh',
  },
];
